// component
import SvgColor from '../../../components/svg-color';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;


// const usuario = JSON.parse(localStorage.getItem('userData'))

const navConfig = [
  {
    title: 'Dashboard',
    path: '/vendas/inicio',
    icon: icon('ic_analytics'),
    supervisor: true
  },
  {
    title: 'Vendas',
    path: '/vendas/vendas',
    icon: icon('ic_cart'),
    supervisor: false
  },
  {
    title: 'Receitas',
    path: '/vendas/receitas',
    icon: icon('layers-outline'),
    supervisor: false
  },
  {
    title: 'Despesas',
    path: '/vendas/despesas',
    icon: icon('layers-outline'),
    supervisor: false
  },
  {
    title: 'Estoque',
    path: '/vendas/estoque',
    icon: icon('inventory2'),
    supervisor: false
  },
  {
    title: 'Cadastros',
    path: '/vendas/cadastros',
    icon: icon('list-outline'),
    supervisor: false
  },
  {
    title: 'Relatórios',
    path: '/vendas/relatorios',
    icon: icon('relatorios'),
    supervisor: true
  }
].filter(Boolean);

export default navConfig;
